import { useSearchStore } from '@/stores/search';
import { SearchResultsProps } from '../types';
import { SearchResultsList } from './SearchResultsList';
import { SearchResultsEmptyState } from './SearchResultsEmptyState';
import { useSearchLegacy as useTypesenseSearchInLegacyUi } from '@/api/typesense/searchLegacy';

export const TypesenseSearchResults = ({
  searchValue,
  onItemSelect,
  searchContainerResults,
}: SearchResultsProps) => {
  const { getSelectedCategoryList } = useSearchStore();
  const { searchResult, isSearchResultEmpty } = useTypesenseSearchInLegacyUi(
    searchValue,
    getSelectedCategoryList(),
  );

  if (!isSearchResultEmpty) {
    return (
      <SearchResultsList
        searchResult={searchResult}
        searchValue={searchValue}
        onItemSelect={onItemSelect}
        searchContainerResults={searchContainerResults}
      />
    );
  }

  if (isSearchResultEmpty) {
    return <SearchResultsEmptyState />;
  }

  return null;
};
